import { BaseModel } from "../../core/src/model/BaseModel"
import IJackpotData from "../server/data/IJackpotData";

class MoWJackpotsModel extends BaseModel<IJackpotData> {
    /**
     * Keeps a value, indicating whether the player is currently playing for jackpot or not.
     *
     * @type {boolean}
     * @memberof MoWJackpotsModel
     */
    public playForJackpot: boolean = false;
    public jackpotWon: boolean = true;
    public jackpotWonName: string = "";
    public winAmount: number = 0;
    public jpAttendanceClientDesired: boolean = false;
    public jackpotFee: number = 0.01;
    public hasDreamDrop: boolean;
    public jackpotWin: number = 0;
    /**
     * Keeps a value, indicating whether the jackpots on the servers are enabled or not.
     *
     * @type {boolean}
     * @memberof MoWJackpotsModel
     */
    public jackpotsAvailable: boolean = false;

    /**
     * Gets or sets the jackpot names, currently available on the game server.
     * The order defines how the jackpot banner will display them:
     * For landspace - jackpots are displayed from top to bottom,
     * For portrait - jackpots are displayed from left to right.
     *
     * @type {string[]}
     * @memberof MoWJackpotsModel
     */
    public jackpotNames: string[];
};

export default new MoWJackpotsModel();